import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Authenticated client — sends the httpOnly session cookie with every request.
const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Public client — for endpoints that do NOT require auth (e.g. loan application
// submission). Never sends credentials so it works cleanly against a wildcard
// CORS origin in production.
export const publicApi = axios.create({
  baseURL: API,
  withCredentials: false,
});

export function formatApiError(err) {
  const detail = err?.response?.data?.detail;
  if (detail == null) return err?.message || "Something went wrong.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
